import TriangleDividerVertical from "../../components/triangle/triangle-divider-vertical"
import useMediaQueries from '../../hooks/useMediaQueries'
import authInfinite from "../../assets/icons/auth-infinite.svg"
import BrandLogo from "../../components/brand-logo";
// import { useLayoutEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { confirmGuestLoginRequest, confirmMessageRequest } from "../../assets/api/userActions";
import { redirectGuestToExamOrJoinPage } from "../../assets/utils/redirectAfterGuestLogin";
import { showAttemptJoinErrorSwal } from "../../assets/utils/attemptJoinErrorSwal";
import './index.scss'
import { useEffect } from "react";

const GuestConfirm = () => {

    const params = useParams();
    const navigate = useNavigate();

    // const paramsName = searchParams.get("name");


    const [loginPhone, setLoginPhone] = useState("");
    const [loginName, setLoginName] = useState("");
    const [loginCode, setLoginCode] = useState("");
    const [isSubmittingCode, setIsSubmittingCode] = useState(false);
    const [isResendingCode, setIsResendingCode] = useState(false);

    const { isAbove922 } = useMediaQueries();

    useEffect(() => {
        const ssRaw = sessionStorage.getItem("guestInfo");
        if (!ssRaw) {
            navigate(`/auth/login/guest/${params.code}`, { replace: true });
            return;
        }
        let ssData = {};
        try {
            ssData = JSON.parse(ssRaw) || {};
        } catch {
            navigate(`/auth/login/guest/${params.code}`, { replace: true });
            return;
        }
        setLoginPhone(ssData.phone || "");
        setLoginName(ssData.name || "");
        // sessionStorage.clear();
        // console.log(ssData);
    }, [navigate, params.code])

    function onGoBackHandler() {
        navigate(`/auth/login/guest/${params.code}`);
    }

    function showResendResult(res) {
        if (res.returnCode === "SUCCESS") {
            Swal.fire({
                icon: "success",
                title: "کد تایید با موفقیت ارسال شد",
                timer: 2000

            })
        }
    }

    async function resHandler(res) {
        if (!res) {
            Swal.fire({
                icon: "error",
                title: "پاسخی از سرور دریافت نشد",
                confirmButtonText: "باشه"
            });
            return;
        }
        if (res.returnCode === "SUCCESS") {
            const today = new Date();
            let tomorrow = new Date();
            const setExpireDate = tomorrow.setDate(today.getDate() + 1);
            const token = res?.quizToken || res?.token;
            if (!token) {
                Swal.fire({
                    icon: "error",
                    title: "توکن ورود دریافت نشد",
                    confirmButtonText: "باشه"
                });
                return;
            }
            localStorage.setItem("userToken", JSON.stringify({
                quizToken: token,
                name: loginName,
                phone: loginPhone,
                role: "guest",
                quizCode: params.code,
                expireDate: setExpireDate
            }));
            // در صورت ناموفق بودن join (مثلا اتمام زمان آزمون یا غیرفعال بودن آن)،
            // به جای پیام «نشست شما منقضی شده» باید پیام مناسب همان وضعیت نمایش داده شود.
            const result = await redirectGuestToExamOrJoinPage(navigate, params.code, { redirectOnFailure: false });
            if (result.entered) {
                return;
            }
            const joinStatus = result.joinResult?.status;
            const isUnauth = result.joinResult?.message === "Unauthenticated.";
            if (joinStatus && joinStatus !== "joined" && !isUnauth) {
                showAttemptJoinErrorSwal(result.joinResult);
                navigate(`/guest/join/${params.code}`, { replace: true });
                return;
            }
            // اگر دلیل خاصی شناسایی نشد، به صفحهٔ اطلاعات آزمون مهمان هدایت می‌شود
            navigate(`/guest/join/${params.code}`, { replace: true });
            return;
        }
        Swal.fire({
            icon: "error",
            title: res?.message || "کد وارد شده معتبر نیست",
            confirmButtonText: "باشه"
        });
    }

    async function onResendCode() {
        if (!minutes && !seconds && !isResendingCode) {
            setIsResendingCode(true);
            try {
                const res = await confirmMessageRequest(loginName, loginPhone, params.code);
                showResendResult(res);
            } finally {
                setIsResendingCode(false);
            }
        }
    }

    const initialMinute = 2, initialSeconds = 0
    const [minutes, setMinutes] = useState(initialMinute);
    const [seconds, setSeconds] = useState(initialSeconds);
    useEffect(() => {
        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval)
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000)
        return () => {
            clearInterval(myInterval);
        };
    }, [minutes, seconds]);

    const onSubmitHandler = async (e) => {
        e.preventDefault();

        if (!loginCode.length) {
            Swal.fire({
                icon: "error",
                title: "شماره خود را وارد کنید",
                confirmButtonText: "باشه"
            })
            return;
        }

        else {
            if (isSubmittingCode) return;
            setIsSubmittingCode(true);
            try {
                const res = await confirmGuestLoginRequest({
                    name: loginName,
                    phone: loginPhone,
                    code: loginCode,
                    quizCode: params.code
                });
                await resHandler(res);
            } finally {
                setIsSubmittingCode(false);
            }
            // const today = new Date();
            // let tomorrow = new Date();
            // const setExpireDate = tomorrow.setDate(today.getDate() + 1);
            // const { token, ...newUserData } = userData;
            // localStorage.setItem("userToken", JSON.stringify({
            //     ...newUserData, userToken: token, "expireDate": setExpireDate
            // }))
        }

    }

    function renderSvgBox() {
        if (isAbove922) {
            return (
                <div className="auth-page__svg-box">
                    <object
                        type="image/svg+xml"
                        data={authInfinite}
                        width="523"
                        height="308"
                    >
                        عکس متحرک
                    </object>
                    <BrandLogo width="128" height="39" className="auth-page__brand-logo" />
                </div>
            );
        }
    }

    return (
        <main className="auth-page">
            {renderSvgBox()}
            <section className="auth-page__content">
                <TriangleDividerVertical />
                <div className="auth-page__form-container">
                    <div className="auth-page--center">

                        <form
                            onSubmit={onSubmitHandler}
                            className="form-login"
                        >
                            <h4 className="login-title">ورود به صورت مهمان</h4>
                            <p className="login-description">کد ارسال شده به شماره {loginPhone} را وارد کنید</p>
                            <div className="d-flex">
                                <input
                                    type="number"
                                    className="input-style"
                                    placeholder="کد ارسال شده"
                                    onChange={(e) => {
                                        setLoginCode(e.target.value);
                                    }}
                                />
                                <div className="login-countdown">
                                    {minutes === 0 && seconds === 0
                                        ? null
                                        : <h1> {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1>
                                    }
                                </div>
                            </div>
                            <div className="d-flex">
                                <button
                                    type="button"
                                    className="link-login auth-link-button"
                                    style={{ padding: "0 25px" }}
                                    disabled={isResendingCode || !!(minutes || seconds)}
                                    onClick={() => onResendCode()}
                                >
                                    {isResendingCode ? "در حال ارسال..." : "ارسال مجدد کد"}
                                </button>
                                <button
                                    type="button"
                                    className="link-login auth-link-button"
                                    style={{ padding: "0 25px" }}
                                    disabled={isSubmittingCode || isResendingCode}
                                    onClick={() => onGoBackHandler()}
                                >
                                    تصحیح شماره
                                </button>
                            </div>
                            <button
                                type="submit"
                                className={`button-login ${isSubmittingCode ? "button-login--loading" : ""}`}
                                disabled={isSubmittingCode}
                            >
                                {isSubmittingCode ? "در حال بررسی..." : "ورود"}
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default GuestConfirm